<template>
    <div class="m-auto px-8 md:px-20">
        <div class="max-w-screen-2xl m-auto">
            <div class="py-5 text-2xl font-bold">
                Dettaglio ruolo
            </div>

            <div v-show="response_message.length" :class="[esito ? 'bg-next-bri' : 'bg-next-orange']" class="text-white p-3 mb-3 flex justify-between items-center">
                {{response_message}}
                <i class="icon-x cursor-pointer" @click="response_message = ''"></i>
            </div>

            <p>Nome ruolo: <span class="font-bold">{{ ruolo.name }}</span></p>
            <div class="pt-5 flex flex-col">

                <Field field_name="Permessi">
                    <VueMultiselect
                            v-model="permessiAutcomplete.selection"
                            :options="permessiAutcomplete.options"
                            placeholder="Permessi"
                            class="next-vue-multiselect"
                            track-by="id"
                            label="name"
                            :multiple="true"
                            selectLabel=""
                            deselectLabel=""
                            selectedLabel=""
                            :internal-search="false"
                            @search-change="permessiAutcomplete.search"
                    >
                        <template v-slot:tag="{option, remove}">
                            <MultiselectOption @remove="remove(option)">
                                {{ option.name }}
                            </MultiselectOption>
                        </template>
                    </VueMultiselect>
                </Field>
            </div>

            <div class="flex pt-3 justify-end">
                <NextButton class="px-3 py-2" @click="save">Salva</NextButton>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import Topbar from "@/components/Topbar.vue";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import ModalFigli from "@/components/ModalFigli.vue";
import NextEditor from "@/components/NextEditor.vue";
import Loading from "@/components/Loading.vue";
import Alert from '@/components/Alert.vue';
import MultiselectOption from "@/components/MultiselectOption.vue";
import Field from "@/components/Field.vue";
import NextButton from "@/components/NextButton.vue";
import Checkbox from "@/components/Checkbox.vue";
import Autocomplete from "@/setup/Autocomplete";
import permessiManager from "@/api/Permessi";
import roleManager from "@/api/Roles";

@Options({
    name: 'DettaglioRuolo',
    components: {
        Checkbox,
        NextButton,
        Topbar,
        NextEditor,
        Breadcrumbs,
        ModalFigli,
        Loading,
        MultiselectOption,
        Field,
        Alert
    },

    props: {
        id: {
            type: [String, Number],
            required: true
        },
        cid: {
            type: [String, Number],
            required: true
        },
    }
})
export default class DettaglioRuolo extends Vue {
    permessiAutcomplete: any = setup(() => Autocomplete(permessiManager, true))

    id!: number
    ruolo = {}
    esito = false
    response_message = ''

    created() {
        this.fetchRole()
    }

    fetchRole() {

        roleManager.role(this.id).then((response) => {
            this.ruolo = response.data
        })

        roleManager.rolePermissions(this.id).then((response) => {
            this.permessiAutcomplete.add(response.data)
        })
    }

    save(){
        this.response_message = ''
        roleManager.savePermissions(this.id, {
            permission_ids: this.permessiAutcomplete.selection.map((e:any)=>e.id),
        }).then(()=>{
            this.esito = true
            this.response_message = 'Salvataggio avvenuto corretamente'
        }).catch(()=>{
            this.esito = false
            this.response_message = 'Salvataggio fallito'
        })
    }

}
</script>


<style lang="scss">

</style>
